import InstanceList from './InstanceList/InstanceList'

export default {
  InstanceList,
}
